export default __webpack_public_path__ + "static/media/topbanner-background.eca15a78.png";